import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';

const TwinklingStar = () => (
    <img src="img/star.png" className="absolute text-white opacity-70 animate-twinkle top-4 left-4" alt="" srcSet="" />
);

const StartupSuccess = () => {
    const successMetrics = [
        { value: "160+", label: "Engaged with over 163 startups in last 10 years" },
        { value: "28+", label: "Help portfolio startups raise 28M+ USD" },
        { value: "64%", label: "Startups achieving growth milestones" },
    ];

    return (
        <div className="bg-gray-50 py-12">
            <div className="max-w-7xl mx-auto md:px-6">
                {/* Header Section */}
                <div className="text-center md:mb-10 mb-4">
                    <h2 className="text-3xl md:text-4xl lg:text-[48px] leading-tight font-bold text-gray-900 tracking-tight">How we do it</h2>
                    <h3 className="text-gray-500 md:mt-3 text-xl md:text-4xl font-medium">
                        A Startup Studio That Builds, Funds & Scales Companies
                    </h3>
                </div>

                {/* Image Section */}
                <div className="md:mb-8 mb-4 overflow-hidden shadow-lg">
                    <img
                        src="img/how-we-do-it.png"
                        alt="Innovation"
                        className="w-full object-cover"
                    />
                </div>

                {/* Description */}
                <div className="text-left md:mb-16 mb-10">
                    <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                        At <span className="font-medium text-gray-800">Turning Ideas</span>, we don’t just advise startups—we
                        <span className="font-medium text-gray-800"> co-build and accelerate them from idea to market leader.</span>
                    </p>
                    <p className="mt-3 text-lg md:text-xl text-gray-600 leading-relaxed">
                        Our structured approach helps
                        <span className="font-medium text-gray-800"> global startups expand in India and Indian startups scale across Asia</span> by offering a
                        <span className="font-medium text-gray-800"> full-stack startup-building model that includes strategy, sales, and product development.</span>
                    </p>
                </div>

                {/* Success Metrics */}
                <div className="mb-12">
                    <div className="text-center text-3xl md:text-4xl font-medium mb-12">
                        <h2 className="text-3xl md:text-4xl lg:text-[48px] leading-tight font-bold text-gray-900 tracking-tight">Success Stories</h2>
                        <h2 className="text-gray-500 md:mt-2">Real Startups, Real Impact</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
                        {successMetrics.map((item, index) => (
                            <div key={index} className="w-full md:w-auto relative">
                                <div className="bg-blue-600 text-white p-6 rounded-xl shadow-md flex flex-col items-center justify-center h-80 overflow-hidden"> {/* overflow-hidden to contain star if needed */}
                                    <span className="text-7xl font-medium relative z-10">{item.value}</span>
                                    {/* <TwinklingStar />
                                    <TwinklingStar /> */}
                                    <TwinklingStar />
                                </div>
                                <p className="text-xl text-start mt-2 font-medium">{item.label}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Logos Carousel */}
                <div className="mb-12">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        breakpoints={{
                            640: { slidesPerView: 1, spaceBetween: 40 },
                            768: { slidesPerView: 2, spaceBetween: 50 },
                            1024: { slidesPerView: 3, spaceBetween: 60 },
                        }}
                        loop={true}
                        modules={[Navigation, Pagination, Autoplay]}
                        // pagination={{ clickable: true }}
                        autoplay={{
                            delay: 3000,
                        }}
                    >
                        {[
                            { img: "/img/logos/your-space.png", name: "Your Space" },
                            { img: "/img/logos/easemygstlogo.png", name: "EaseMyGST" },
                            { img: "/img/logos/turninglogo.png", name: "TurningCloud" },
                            { img: "/img/logos/your-space.png", name: "Your Space" },
                            { img: "/img/logos/easemygstlogo.png", name: "EaseMyGST" },
                            { img: "/img/logos/turninglogo.png", name: "TurningCloud" },
                        ].map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="flex items-center justify-center">
                                    <img src={item.img} alt={item.name} className="max-h-24 max-w-full object-contain" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {/* CTA Button */}
                <div className="text-center ">
                    <a href="/about">
                        <button className="px-6 py-2 bg-blue-600 text-white font-semibold text-md rounded-full hover:bg-blue-700 transition-colors duration-300">
                            Explore Our Impact
                        </button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default StartupSuccess;